import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getForexSetting() {
        try{            
            const response = await axios.get(`Client/forex-setting`)                       
            return response
        }catch (error){
            console.log('Client api getForexSetting error')
            throw error
        }
    },
    async get() {
        try{            
            const response = await axios.get(`Client`,
            {
                headers: {
                    'page_key': pageKeys.client
                }
            })                       
            return response
        }catch (error){
            console.log('Client api get error')
            throw error
        }
    },
    async update(data) {
        try{            
            const response = await axios.post(`Client`, 
            {
                client: data
            },
            {
                headers: {
                    'page_key': pageKeys.client
                }
            })             
            return response
        }catch (error){
            console.log('Apps api update error')
            throw error
        }
    },
    async updateForexSetting(data) {
        try{            
            const response = await axios.post(`Client/forex-settings`, 
            {
                forexSettings: data
            },
            {
                headers: {
                    'page_key': pageKeys.client
                }
            })             
            return response
        }catch (error){
            console.log('Apps api update error')
            throw error
        }
    },
}